{
  "success": {
    "default": "Operation succeed",
    "save": "Saved",
    "remove": "Successful removal",
    "detach": {
      "user": "The following user has been detached from the sector { sectorName } | The following users has been detached from the sector { sectorName }",
      "device": "The following device has been detached from the sector { sectorName } | The following devices has been detached from the sector { sectorName }",
      "application": "The following application has been detached from the sector { sectorName } | The following applications has been detached from the sector { sectorName }",
      "userGroup": "The following users group has been detached from the sector { sectorName } | The following users groups has been detached from the sector { sectorName }",
      "dtwins": "The following device has been detached from the sector { sectorName } | The following devices has been detached from the sector { sectorName }"
    },
    "attach": {
      "user": "The following user has been attached to the sector { sectorName } | The following users has been attached to the sector { sectorName }",
      "device": "The following device has been attached to the sector { sectorName } | The following devices has been attached to the sector { sectorName }",
      "application": "The following application has been attached to the sector { sectorName } | The following applications has been attached to the sector { sectorName }",
      "userGroup": "The following users group has been attached to the sector { sectorName } | The following users groups has been attached to the sector { sectorName }",
      "dtwins": "The following device has been attached to the sector { sectorName } | The following devices has been attached to the sector { sectorName }"
    },
    "certificate": {
      "generation": "The user certificate is successfully generated."
    }
  },
  "cancellation": {
    "cancel": "Edition cancelled"
  },
  "inProgress": {
    "save": "Save in progress"
  },
  "error": {
    "default": "An error occurred",
    "unexpectedApiError": "Unexpected Api Error",
    "save": "Save failed",
    "remove": "The removal was not successful",
    "upload": "Upload failed, please try again",
    "detach": {
      "user": "The detachment from the sector { sectorName } of the following user failed | The detachment from the sector { sectorName } of the following users failed",
      "device": "The detachment from the sector { sectorName } of the following device failed | The detachment from the sector { sectorName } of the following devices failed",
      "application": "The detachment from the sector { sectorName } of the following application failed | The detachment from the sector { sectorName } of the following applications failed",
      "userGroup": "The detachment from the sector { sectorName } of the following users group failed | The detachment from the sector { sectorName } of the following users groups failed",
      "dtwins": "The detachment from the sector { sectorName } of the following device failed | The detachment from the sector { sectorName } of the following devices failed"
    },
    "attach": {
      "user": "The attachement to the sector { sectorName } of the following user failed | The attachement to the sector { sectorName } of the following users failed",
      "device": "The attachement to the sector { sectorName } of the following device failed | The attachement to the sector { sectorName } of the following devices failed",
      "application": "The attachement to the sector { sectorName } of the following application failed | The attachement to the sector { sectorName } of the following applications failed",
      "userGroup": "The attachement to the sector { sectorName } of the following users group failed | The attachement to the sector { sectorName } of the following users groups failed",
      "dtwins": "The attachement to the sector { sectorName } of the following device failed | The attachement to the sector { sectorName } of the following devices failed"
    },
    "campaign": {
      "firmware": "Firmware update could not be scheduled at the desired date"
    },
    "startDate": "The campaign has already started, you cannot modify the start & end date.",
    "keystore": {
      "aliasAlreadyUsed": {
        "title": "Alias is already used",
        "message": "Use another certificate alias and retry."
      }
    },
    "certificate": {
      "parsing": "Certificate error",
      "notValid": "The API certificate value is not valid"
    }
  }
}
